export interface SuggestionReason {
  feedbackCode: string;
  feedbackName: string;
}

export enum SuggestionStatus {
  ALL = 'all',
  PENDING = 0,
  ARCHIVED = 1,
}

export interface SuggestionListQuery {
  currentPage: number;
  pageSize: number;
  id?: string;
  feedbackCode?: string;
  status?: SuggestionStatus;
  createUserId?: string;
  suppId?: string;
}

export interface Suggestion {
  updateTime: string | number | Date | Dayjs | null | undefined;
  updateUserName: any;
  operateTime: string | number | Date | Dayjs | null | undefined;
  operateUserName: any;
  id: string;
  feedbackCode: string;
  feedbackName: string;
  userRemark: string;
  userImageUrls: string;
  conclusion: string;
  productImproveMethod: string;
  userMsgContent: string;
  cover?: string;
  ratio?: number;
  status: SuggestionStatus;
  createTime: string;
  createUserId: string;
  viewUserId: string;
  viewTime: string;
  userNumber: string;
  name: string;
  nickName: string;
  deviceType?: number;
  suppId?: string;
  vipName?: string; // 会员类型
}

export interface SuggestionList {
  records: Suggestion[];
  total: number;
  currentPage: number;
  pageSize: number;
}

export interface ArchiveSuggestionParams {
  id: string;
  conclusion: string;
  productImproveMethod: string;
  userMsgFlag?: number; // 0: not send, 1: send
  userMsgContent?: string;
  cover?: string; // 回复用户的封面图URL
  ratio?: number; // 封面图宽高比 width/height
}
